import React from "react";
import { useSelector } from "react-redux";
import Avatar from "../../form/front/Avatar";

const CompanyCard = () => {
  const { session } = useSelector((state) => state?.authProvider);

  const user = session?.user;

  const fullName =
    user?.firstName && user?.lastName
      ? `${user.firstName} ${user.lastName}`
      : "Unknown User";

  const userEmail = user?.email || "No email available";

  const userImage = user?.image?.url;

  return (
    <div className="bg-white p-2 xl:p-4 rounded-lg shadow-md">
      {/* Header */}
      <div className="flex gap-3">
        {/* {userImage ? (
          <img
            src={userImage}
            alt={fullName}
            className="w-16 h-16 rounded-full object-cover flex-shrink-0"
          />
        ) : (
          <div className="w-12 h-12 rounded-full bg-gray-200 flex items-center justify-center text-lg font-semibold text-gray-600 flex-shrink-0">
            {fullName.charAt(0)}
          </div>
        )} */}
         <Avatar image={userImage} name={fullName.charAt(0)} size={40} />

        <div className="min-w-0">
          <div className="font-semibold text-base text-gray-800">
            {fullName}
          </div>

          {/* Email wrap */}
          <p className="text-[13px] text-gray-500 break-all">
            {userEmail}
          </p>
        </div>
      </div>

      {/* Body */}
      <div className="mt-3 text-gray-600 text-sm font-sans">
        <p>{user?.firstName}, welcome back 👋</p>
        <p className="text-gray-500 mt-1">
          Discover companies and jobs tailored for you.
        </p>
      </div>
    </div>
  );
};

export default CompanyCard;
